export default __webpack_public_path__ + "static/media/EM0760.34I-22661_-15271_0.eb56df59.jpg";